import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  IStyleableComponentProps,
  ITestableComponent,
} from "../common/component-props";
import Tooltip from "../tooltip";
import styles from "./user-guide-tooltip.module.scss";
import Button from "../button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { IAppState } from "../../../redux/reducers";
import { ThunkDispatch } from "redux-thunk";
import { Action } from "redux";
import {
  tooltipUserGuideActions,
  TooltipUserGuideEntityName,
  tooltipUserGuideVisibleEntityOrder,
} from "../../../redux/actions/tooltip-user-guide";
import { connect } from "react-redux";
import Checkbox from "../input/checkbox";
import { accountService } from "api/services/account-service";

interface IUserGuideTooltipProps
  extends IStyleableComponentProps,
    ITestableComponent,
    ReturnType<typeof mapStateToProps>,
    ReturnType<typeof mapDispatchToProps> {
  entityName: TooltipUserGuideEntityName;
}

function UserGuideTooltip(props: IUserGuideTooltipProps) {
  const [isDoNotShowChecked, setDoNotShowChecked] = useState<boolean>(
    accountService.getTooltipUserGuideState().showTooltip
  );

  useEffect(() => {
    if (props.open) {
      let tooltipUserGuideState = accountService.getTooltipUserGuideState();

      setDoNotShowChecked(!tooltipUserGuideState.showTooltip);
      console.log("state: ", tooltipUserGuideState, "props: ", props)
      if (props.entityName === "firstStep") {
        setTimeout(() => props.nextStep(), 300);
      }

    }
    // eslint-disable-next-line
  }, [props.open]);

  function getTooltipBody() {
    return (
      <>

        <div className={styles.desc}>{props.tooltipText}</div>

        <Button
          className={styles.close}
          onClick={() => {
            accountService.setTooltipUserGuideState(!isDoNotShowChecked);
            props.tooltipUserGuideClose()
          }}
          testId="close"
        >
          <CloseIcon viewBox="5 5 14 14" />
        </Button>

        {props.stepCounterEnabled && (
          <>
            <div className={styles["step-count"]}>
              {props.currentStep} / {props.stepCount}
            </div>

            <div className={styles["navigation-buttons"]}>
              <Button
                testId="user-guide-tooltip-previous-step"
                disabled={props.currentStep === 1}
                onClick={props.previousStep}
              >
                <NavigateBeforeIcon />
              </Button>
              <Button
                testId="user-guide-tooltip-next-step"
                disabled={props.currentStep === props.stepCount}
                onClick={props.nextStep}
              >
                <NavigateNextIcon />
              </Button>
            </div>
          </>
        )}

        {props.currentStep === props.stepCount && (
          <>
            <div className={styles["checkbox--do-not-show-again"]}>
              <Checkbox
                testId="tooltip-do-not-show-again"
                checked={isDoNotShowChecked}
                onChange={(value) => {
                  setDoNotShowChecked(value);
                  accountService.setTooltipUserGuideState(!value);
                }}
              />

              <div>Do not show again</div>
            </div>
          </>
        )}
      </>
    );
  }

  return props.open && props.entityName === "firstStep"
    ? <></>
    : (
      <Tooltip
        title={getTooltipBody()}
        open={props.open && props.entityName === props.tooltipUserGuideEntity}
      >
        <div />
      </Tooltip>
    );
}

const mapStateToProps = (state: IAppState) => ({
  open: state.tooltipUserGuide.open,
  tooltipUserGuideEntity: state.tooltipUserGuide.currentEntity,

  currentStep:
    tooltipUserGuideVisibleEntityOrder.indexOf(state.tooltipUserGuide.currentEntity) +
    1,
  stepCount: tooltipUserGuideVisibleEntityOrder.length,
  stepCounterEnabled: state.tooltipUserGuide.stepCounterEnabled,

  tooltipText:
    state.tooltipUserGuide.tooltipText[state.tooltipUserGuide.currentEntity],
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    nextStep: () => {
      dispatch(tooltipUserGuideActions.nextStep());
    },
    previousStep: () => {
      dispatch(tooltipUserGuideActions.previousStep());
    },
    tooltipUserGuideClose: () => {
      dispatch(tooltipUserGuideActions.close());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserGuideTooltip);
